<template>
  <div class="modalBigImageQuestion">
    <div style="border-radius:10px;padding:10px;" class="bloc">
      <img
        @click="closeModalBigImageQuestion()"
        src="@/assets/img/icons/close-icon.png"
        alt="close-icon"
        class="icon-close"
      />
     <img :src="modalBigImageQuestion.urlBigImageQuestion"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalBigImageQuestion',
  props: ['modalBigImageQuestion'],
  data () {
    return {
      window: {
        width: 0
      },
      modalWidth: 0,
      qrcodeWidth: 0
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  created () {
    this.$store.commit('SET_AUTHORIZED_PREVIEW', false)
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  methods: {
    closeModalBigImageQuestion () {
      this.$store.commit('MODAL_BIGIMAGEQUESTION', {
        urlBigImageQuestion: '',
        activeModalBigImageQuestion: false,
      })
    },
    handleResize () {
      this.window.width = window.innerWidth
      if (window.innerWidth > 500) {
        this.modalWidth = window.innerWidth - window.innerWidth / 2
        this.qrcodeWidth = this.modalWidth / 2
      } else {
        this.modalWidth = window.innerWidth
        this.qrcodeWidth = this.modalWidth - 130
      }
    }
  }
}
</script>
<style scoped>
.modalBigImageQuestion {
  text-align: center;
  -webkit-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
  margin: 50px;
}
.icon-close {
  width: 20px;
  height: 20px;
  cursor: pointer;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/sondage/components/ModalBigImageQuestion.vue